export enum AuthRoutes {
    LOGIN = 'login',
    REFRESH = '',
    CONFIRM = 'confirm',
    PASSWORD_RESET = 'password-reset',
}
